import { HoaiWordmark } from "@/components/hoai-wordmark";

/**
 * Centered branded card used by the auth surfaces (/signin, /accept).
 * Mirrors the design-kit AuthShell: muted backdrop, wordmark lockup, optional
 * footer line. Pass `footer={null}` to hide the default footer.
 */
export function AuthShell({
  children,
  footer,
}: {
  children: React.ReactNode;
  footer?: React.ReactNode;
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-[18px] bg-muted px-5 py-10">
      <div className="w-full max-w-[384px] rounded-md border border-border bg-background px-[30px] py-8 shadow-[0_2px_8px_rgba(0,0,0,0.06)]">
        <div className="mb-6 flex items-center">
          <HoaiWordmark className="h-[23px] w-auto text-foreground" />
        </div>
        {children}
      </div>
      {footer !== undefined ? (
        footer
      ) : (
        <p className="text-sm text-muted-foreground">
          Trusted community management, automated.
        </p>
      )}
    </div>
  );
}
